const removeKey = (key, { [key]: _, ...rest }) => rest;

const validateObj = (obj, newObj, item) => {
  for (const [p, val] of Object.entries(newObj)) {
    // if (val !== undefined) {
    console.log(p);
    if (
      newObj[p] === "" ||
      newObj[p] === obj[p] ||
      newObj[p] === obj[p]?._id ||
      newObj[p] === undefined ||
      newObj[p] === [] ||
      p === "questionBlocks"
    ) {
      const rest = removeKey(p.toString(), newObj);
      newObj = rest;
    }
    // }
  }
  return newObj;
};

export default validateObj;
